/**
 * Thẻ đám đông — ảnh nhóm (đợt 260922 E3-P6). Logic THUẦN, tách khỏi file import antd để jest chạy được.
 *
 * `crowdGroupSize` là BẢN SAO luật backend (`admin-service/src/utils/filmCrowdGroup.ts`) — sửa một bên thì sửa bên kia, test cùng ca.
 */
import type { RefAssetState } from './refAssetUtils';

export function crowdGroupSize(headcount?: number | null): number {
  const h = Number(headcount);
  if (!Number.isFinite(h) || h <= 0) return 5;
  return Math.min(6, Math.max(2, Math.round(h)));
}

export interface CrowdGenState { canGen: boolean; label: string; hint: string }

/** Nút gen ảnh nhóm: mô tả trống ⇒ tắt (chỉ có tên thì ảnh ra ngẫu nhiên — cùng luật `planCrowdImage` backend). */
export function crowdGenState(c: { casting?: string | null; groupRefUrl?: string | null; headcount?: number | null }): CrowdGenState {
  const label = c.groupRefUrl ? 'Gen lại ảnh nhóm' : 'Gen ảnh nhóm';
  if (!String(c.casting || '').trim()) return { canGen: false, label, hint: 'Nhập mô tả nhóm trước (họ là ai, mặc gì) — chỉ có tên thì ảnh ra ngẫu nhiên.' };
  return { canGen: true, label, hint: `Ảnh sẽ có ${crowdGroupSize(c.headcount)} người khác nhau, một hàng, nền trắng.` };
}

/**
 * Được bấm "Đăng ký AVIS" tay không. KHÔNG khi `failed`: AVIS đã từ chối ảnh nhóm này thì thử lại vẫn bị, mỗi lần là một asset `failed`
 * vĩnh viễn (backend cũng chặn — `blockAfterFailed`). `unknown` ⇒ đối soát; `processing` / `active` ⇒ không cần.
 */
export function crowdCanRegisterAvis(state: RefAssetState): boolean {
  return state === 'none' || state === 'stale';
}

/** Câu xác nhận gen lại. Chỉ hứa "tự đăng ký KYC" khi server nói công tắc đang bật. Không chữ giá. */
export function crowdRegenConfirm(avisAuto: boolean): string {
  return avisAuto
    ? 'Ảnh đang dùng sẽ bị thay (không lấy lại được trên UI). Ảnh mới tự đăng ký KYC trên AVIS — thêm một asset, không xoá được.'
    : 'Ảnh đang dùng sẽ bị thay (không lấy lại được trên UI). Ảnh mới CHƯA đăng ký AVIS — đăng ký tay ở menu ⋯ khi ảnh đã đạt.';
}
